module.exports = "https://bin.bnbstatic.com/_next/static/images/about-careers-e9f029cfe40e80c9adce6eca81edc618.jpg";